<template>
    <span class="interval">
        <div class="interval-label main-text-color" v-if="label">
            {{ $t(label) }}
        </div>
        <el-input-number :value="inputValue" @input="onChange" :min="0" :placeholder="placeholder" :disabled="disabled"></el-input-number>
    </span>
</template>

<script>
import { InputNumber } from 'element-ui'

export default {
    components: {
        [InputNumber.name]: InputNumber, 
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: '' 
        },
        placeholder: {
            type: String,
            default: '' 
        },
        inputValue: {
            type: [Number, String]
        }
    },
    methods: {
        onChange (val) {
            const data = {
                value: val,
                component: this.$attrs
            }
            this.$emit('change', data)
        }
    }
};
</script>

<style lang="scss" scoped>
.interval-label {
    @apply mb-2;
}
[dir="rtl"] .interval-label {
    @apply ml-3;
}
[dir="ltr"] .interval-label {
    @apply mr-3;
}
.el-form-item__error {
    @apply pt-2;
}
.interval {
    @apply relative;
}
::v-deep .el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled), ::v-deep .el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
    @apply border-primary;
}
</style>